/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Avatar({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Avatar"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let cardPatientValueData = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'patient',
format: fromFormat.initials,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<button
  data-testid="Avatar.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-2ktN6P': dtColorsNeutral200,'--btlr-2-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--btrr-3-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bblr-4-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bbrr-5-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--mr-6-2ktN6P': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-7-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--w-8-2ktN6P': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 size="medium"
 data="card.patient"
 format="/Data/format.js initials"
 text={cardPatientValueData}
/>
</button>
{children}
</React.Fragment>)
}